window.AutorizadoOrcamentoController = ControllerBase.extend({
    name: "AutorizadoOrcamentoController",
    framework: "knockout",
    region: '#autorizado-main-region',
    ajax: function () {

        return {
            url: "/Orcamento/_Autorizado",
            type: "post",
            cache: false,
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento")
            }
        };
    },

    newModel: function () {
        return {
            Senha: null,
            Nome: null,
            Observacao: null,
            Autorizados: [],
            AutorizadoSelecionado: null,
            AutorizadosOrcamento: [],
            incluir: true,
            novo: true
        };
    },

    antesBinding: function () {

        if (!this.model.Autorizados) {
            this.appendToModel({ name: "Senha", value: null });
            this.appendToModel({ name: "Autorizados", value: [] });
            this.appendToModel({ name: "AutorizadoSelecionado", value: null });
        }

    },

    atualizarBotoes: function () {

        if (!this.model.novo() && this.model.permitidoExcluir()) {
            this.getActionButton({ text: "Limpar" }).show();
        } else {
            this.getActionButton({ text: "Limpar" }).hide();
        }

    },

    aposBinding: function () {

        //this.atualizarBotoes();
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });

        $('#SenhaAutorizadoOrcamento').focus();
    },

    antesRenderizacaoCompleta: function () {

        this.addActionButton({
            text: "Limpar",
            'class': "icone-excluir separador",
            click: $.proxy(function () {

                this.remover();

            },
                this)
        },
            true);

    },

    renderizacaoCompleta: function () {
        $('#detalhe-resumo-orcamento-region').hide();
        $('#detalhe-finalizar-orcamento-region').hide();
    },

    remover: function () {

        var self = this;

        global.ajax({
            url: "/Orcamento/RemoverAutorizado",
            type: "post",
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento")
            },
            success: function (data) {

                if (!data) {
                    return;
                }

                self.limpar();


            }
        });
    },

    limpar: function () {
        this.model.Senha(undefined);
        this.model.Nome(undefined);
        this.model.Observacao(undefined);
        this.model.Autorizados(undefined);
        this.model.AutorizadoSelecionado(undefined);
        this.model.novo(true);
    },

    cancelar: function () {
        this.model.incluir(false);
    },

    decidirAcao: function () {
        if (this.model.Senha && this.model.Senha()) {
            this.autorizar();
        } else {
            this.pesquisar(this.model);
        }
    },

    pesquisar: function (model, e, page) {

        var self = this;
        
        var filtros = {
            TamanhoPagina: 20,
            NumeroPagina: page ? page : 1,
            IdentificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
            Nome: this.model.Nome()
        };


        global.ajax({
            url: "/Orcamento/ListarAutorizados",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({ filtros: filtros }),
            success: function (data) {
                if (!data) {
                    return;
                }

                if (data.Error) {
                    if (data.Error || data.Error() !== "") {  // FNX-1092
                        return;
                    }
                }

                
                var m = ko.mapping.fromJS(data.Entities);
                
                model.Autorizados(m());

                this.paginador = new Paginator({
                    container: "#page-autorizado",
                    data: data,
                    pageClickCallback: $.proxy(self.paginar, self)
                });

            }
        });

    },

    paginar: function (e) {
        this.pesquisar(this.model, null, e.page);
    },

    selecionar: function (model) {

        $.each(this.model.Autorizados(),
            function () {
                this.selecionado(false);
            });


        model.selecionado(true);
        this.model.AutorizadoSelecionado(model);

    },

    autorizar: function (model) {

        var self = this;


        global.ajax({
            url: "/Orcamento/DefinirAutorizado",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                definirAutorizado: {
                    IdentificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                    Senha: this.model.Senha(),
                    Observacao: this.model.Observacao(),
                    CodigoAutorizado: model && model.Codigo ? model.Codigo() : null
                }
            }),
            success: function (data) {

                if (!data || data.HasErrors) {
                    return;
                }

                global.showSuccessMessage("Autorizado definido com sucesso");
                self.model.novo(false);
                self.model.Nome(data.Autorizado.Nome);
                self.model.Observacao(data.Autorizado.Observacao);
                if (self.finalizarCallback) {
                    self.finalizarCallback();
                }
            }
        });

    },


});